/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useMemo, useCallback, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Message from "components/Common/Message";
import Header from "containers/Common/HeaderContainer";
import JobsTable from "containers/Tables/JobsContainer";
import PageWrapper from "hoc/PageWrapper";
import withAbilityCreateJob from "hoc/withAbilityCreateJob";
import { PLANS_NAMES } from "configs/plans";
import { FiPlus } from "react-icons/fi";

import { connect } from "react-redux";
import EmptyStateHeader from "views/EmptyState/EmptyStateHeader.tsx";
import EmptyStateCarousel from "views/EmptyState/EmptyStateCarousel.tsx";
import Carousel from "components/Common/Carousel/Carousel.tsx";
import { isMobile } from "react-device-detect";
import { getIsJobsLoading } from "store/modules/jobs/selectors";
import useOBLandingStore from "store/useOBLandingStore.ts";
import startTemplateImg from "../../assets/images/landing/start-template.json";
import startInterviewImg from "../../assets/images/landing/start-interview.json";
import viewDemoImg from "../../assets/images/landing/view-demo.json";
import Filters from "./Filters";

const newFilter = { title: "", companies: [], owners: [], statuses: [] };

const Jobs = ({
  t,
  dataJobs = [],
  history,
  clearBillingError,
  clearSetupState,
  clearQuestionsState,
  clearPreviewState,
  clearStatuses,
  success,
  error,
  currentUser: { plan_name: planName },
  redirectTo,
  isLoadingFilters,
  filters,
  isJobsLoading,
  clearCurrentJob
}) => {
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState(newFilter);
  const [updated, setUpdated] = useState(false);
  const { configuration, getConfigurations } = useOBLandingStore();
  const [showList, setShowList] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => {
    getConfigurations();
  }, []);

  useEffect(() => {
    if (search || dataJobs.length > 0 || isJobsLoading) {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      setShowList(true);
    } else {
      timeoutRef.current = setTimeout(() => {
        setShowList(false);
      }, 1000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [search, dataJobs, isJobsLoading]);


  const clearFilter = useCallback(() => {
    setSearch("");
    setFilter(newFilter);
  }, []);

  const isFreeInterviewsFinished = useMemo(
    () => planName === PLANS_NAMES.freeForever && dataJobs.length > 0,
    [planName, dataJobs.length]
  );

  const handleCreateJob = useCallback(() => {
    if (isFreeInterviewsFinished) {
      return redirectTo(
        "/plans?utm_source=internal&utm_medium=user&utm_campaign=locked_interviews"
      );
    }
    clearBillingError();
    clearCurrentJob();
    clearStatuses();
    clearSetupState();
    clearQuestionsState();
    clearPreviewState();
    history.push("/jobs/create");
  }, [
    isFreeInterviewsFinished,
    redirectTo,
    clearBillingError,
    clearStatuses,
    clearSetupState,
    clearQuestionsState,
    clearPreviewState,
    history
  ]);

  const carouselItems = useMemo(() => [
    {
      id: "start-template",
      title: {
        text: t("job.onboarding.getStarted.startTemplate.title")
      },
      description: {
        text: t("job.onboarding.getStarted.startTemplate.description")
      },
      headerMedia: {
        src: startTemplateImg,
        type: "lottie",
        className: "w-96 max-h-none"
      },
      button: {
        text: t("job.onboarding.getStarted.startTemplate.button"),
        color: "primary",
        to: "/jobs/template"
      }
    },
    {
      id: "create-interview",
      title: {
        text: t("job.onboarding.getStarted.createInterview.title")
      },
      description: {
        text: t("job.onboarding.getStarted.createInterview.description")
      },
      headerMedia: {
        src: startInterviewImg,
        type: "lottie",
        className: "w-96 max-h-none"
      },
      button: {
        text: t("job.onboarding.getStarted.createInterview.button"),
        iconRight: <FiPlus size={18} />,
        color: "primary",
        dropdownOptions: [
          { label: t("button.create"), onClick: handleCreateJob },
          { label: t("button.browseTemplates"), to: "/jobs/template" }
        ]
      }
    },
    {
      id: "view-demo",
      title: {
        text: t("job.onboarding.getStarted.ourDemo.title")
      },
      description: {
        text: t("job.onboarding.getStarted.ourDemo.description")
      },
      headerMedia: {
        src: viewDemoImg,
        type: "lottie",
        className: "w-96 max-h-none"
      },
      button: {
        text: t("job.onboarding.getStarted.ourDemo.button"),
        color: "primary"
      },
      openIn: "modal",
      embedCode: configuration?.demo_video_link
    }
  ], [t, handleCreateJob, configuration?.demo_video_link]);

  const renderMessageSection = useMemo(() => {
    if (!success && !error) return null;

    return (
      <div className="jobs__message">
        {success && <Message success message={t(success)} />}
        {error && <Message error message={t(error)} />}
      </div>
    );
  }, [success, error, t]);


  return (
    <PageWrapper header={<Header />}>
      <EmptyStateHeader handleCreateJob={handleCreateJob} />

      <Container
        className="jobs"
        style={{
          paddingBottom: 10,
          display: showList ? "block" : "none"
        }}
      >
        <Filters
          search={search}
          setSearch={setSearch}
          isLoading={isLoadingFilters}
          filters={filters}
          filter={filter}
          setFilter={setFilter}
          clearFilter={clearFilter}
        />

        <Col md={12}>
          {renderMessageSection}
        </Col>

        <Row justify="center">
          <Col md={12}>
            <JobsTable
              filter={filter}
              clearFilter={clearFilter}
              updated={updated}
              setUpdated={setUpdated}
            />
          </Col>
        </Row>
      </Container>

      <div
        className="container pb-16"
        id="empty-state-landing"
        style={{
          paddingLeft: isMobile ? undefined : 0,
          paddingRight: isMobile ? undefined : 0
        }}
      >
        <Carousel
          showArrows={false}
          displayAllInMobile
          title={t("job.onboarding.getStarted.title")}
          items={carouselItems}
        />
      </div>
      <EmptyStateCarousel />
    </PageWrapper>
  );
};

Jobs.defaultProps = {
  success: undefined,
  error: undefined,
  isJobsLoading: false
};

Jobs.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func,
    length: PropTypes.number
  }).isRequired,
  filters: PropTypes.shape({
    companies: PropTypes.arrayOf(PropTypes.any),
    owners: PropTypes.arrayOf(PropTypes.any),
    statuses: PropTypes.arrayOf(PropTypes.any)
  }).isRequired,
  dataJobs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  clearBillingError: PropTypes.func.isRequired,
  clearSetupState: PropTypes.func.isRequired,
  clearQuestionsState: PropTypes.func.isRequired,
  clearPreviewState: PropTypes.func.isRequired,
  clearStatuses: PropTypes.func.isRequired,
  success: PropTypes.string,
  error: PropTypes.string,
  currentUser: PropTypes.shape({
    plan_name: PropTypes.string,
    key: PropTypes.string
  }).isRequired,
  redirectTo: PropTypes.func.isRequired,
  isLoadingFilters: PropTypes.bool.isRequired,
  isJobsLoading: PropTypes.bool
};

const mapStateToProps = state => ({
  isJobsLoading: getIsJobsLoading(state)
});

export default connect(mapStateToProps)(withAbilityCreateJob(withTranslation()(Jobs)));
